import React from 'react';
import KeyFact from './KeyFact';
import styles from './KeyFact.scss';

interface PriceKeyFactProps {
  value?: string | number | React.ReactElement;
}

export const PriceKeyFact = ({ value }: PriceKeyFactProps) => {
  return (
    <KeyFact
      value={value}
      extraStyleNames={[styles['key-fact__value--price']]}
    />
  );
};
